module.exports = require("mdi-react/MenuRightIcon");